import Link from 'gatsby-link'
import { Location } from 'history'
import * as React from 'react'
import Helmet from 'react-helmet'
import * as SiteConfig from '../../data/SiteConfig'
import { isMobile } from '../components/generic/Helpers'
import PageContainer from '../components/generic/PageContainer'
import GinfoNavigation from '../components/GinfoNavigation'
import SEO from '../components/SEO/SEO'
import { Site } from '../graphql-types'
import '../style/style.sass'
interface ITemplateProps {
  children: () => JSX.Element
  location: Location
}

const Template = ({ children, location }: ITemplateProps) => {
  return <div>
    <Helmet
      titleTemplate={'%s | ' + SiteConfig.siteTitle}
      defaultTitle={SiteConfig.siteTitle}
      meta={[
        {
          name: 'description',
          content: SiteConfig.siteDescription,
        },
        {
          name: 'keywords',
          content: SiteConfig.siteKeywords,
        },
        { name: 'theme-color', content: '#ffffff' },
      ]}
      link={[
        {
          rel: 'apple-touch-icon',
          sizes: '180x180',
          href: '/apple-touch-icon.png',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: '/favicon-32x32.png',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '16x16',
          href: '/favicon-16x16.png',
        },
        { rel: 'manifest', href: '/manifest.json' },
        { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#24476c' },
        {
          href:
          'https://fonts.googleapis.com/css?family=RobotoDraft:400,500,700,400italic',
          rel: 'stylesheet',
          type: 'text/css',
        },
        {
          href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
          rel: 'stylesheet',
        },
      ]}
      script={[
        {
          src: 'https://code.jquery.com/jquery-3.2.1.min.js',
          integrity: 'sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=',
          crossorigin: 'anonymous',
        },
        {
          type: 'text/javascript',
          src: 'https://cdnjs.cloudflare.com/ajax/libs/materialize/0.100.2/js/materialize.min.js',
        },
        {
          type: 'text/javascript',
          src: '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
          async: true,
        },
      ]}
    />
    <SEO />
    <GinfoNavigation
      currentPath={location.pathname}
      mobile={typeof (window) !== 'undefined' ? isMobile(window.navigator) : false}
    />
    <PageContainer containerClass='container'>
      {children()}
    </PageContainer>
    <footer className='page-footer'>
          <div className='footer-copyright'>
            <div className='container'>
            © 2018 Innovaptor OG
            <Link
              className='grey-text text-lighten-4 right'
              to={'privacy_policy'}
            >
            Privacy Policy
            </Link>
            </div>
          </div>
        </footer>
  </div>
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.tsx